import { combineReducers, configureStore } from '@reduxjs/toolkit'
import promise from 'redux-promise-middleware'

import * as reducers from '../reducers/all'
import myListingFormCompletion from '../dashboard/MyListings/Edit/formCompletionReduxSlice'
import selectEscapeReducer from '../components/SelectEscape/reduxSlice'
import networkMiddleware from './networkMiddleware'
import createAppHistory, { CreateHistoryOptions } from '../appHistory'

export type { CreateHistoryOptions } from '../appHistory'

const rootReducer = combineReducers({
  ...reducers,
  myListingFormCompletion,
  selectEscapeReducer,
})

type ConfigureOptions = {
  skipImmutableCheck?: boolean
  skipSerializableCheck?: boolean
  forceMemoryHistory?: boolean
}

const configure = (
  preloadedState = {},
  createHistoryOptions: CreateHistoryOptions = { initialEntries: ['/'] },
  options?: ConfigureOptions,
) => {
  const history = createAppHistory(
    createHistoryOptions,
    options?.forceMemoryHistory,
  )

  return {
    store: configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) =>
        // using methods on the object returned by getDefaultMiddleware maintains TS typings for middleware
        getDefaultMiddleware({
          serializableCheck:
            options?.skipSerializableCheck != null
              ? options?.skipSerializableCheck !== true
              : {
                  // We use redux-promise-middleware to wrap AJAX requests, and write the payload to the redux store.
                  // The library used to make these requests adds properties to the payload object that get flagged as
                  // 'unserializable' by the serializability dev check middleware (included by default):
                  // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
                  ignoredActionPaths: ['payload.config', 'payload.request'],
                },
          immutableCheck: options?.skipImmutableCheck !== true,
        }).prepend(promise, networkMiddleware),
      preloadedState,
    }),
    history,
  }
}

export type RootState = ReturnType<typeof rootReducer>

export default configure
